import { Scroll } from "@react-three/drei"

export default function Storytelling(props)
{  

    return <>
        <Scroll html style={{ width: '100%' }}>
            <div className="storytelling__text" style={{ top: `50vh` }}>
                <h2>Overall</h2>
                <hr></hr>
                <p>
                Located in what’s probably the city’s most extraordinary place, this kiosk in Times Square is surrounded by commercial, office, and hotel buildings. It is also surrounded by pure chaos at most hours of the day. 
                </p>
            </div>

            <div className="storytelling__text" style={{ top: `150vh` }}>
                <h2>Site</h2>
                <hr></hr>
                <p>
                A festive mix of tourists, entertainers, commuters, loiterers, halal vendors, caricature artists, hat vendors, police officers, and security guards spend time around this site. As you may expect, this makes access and usage of the kiosk somewhat contentious. </p>
            </div>

            <div className="storytelling__text" style={{ top: `250vh`, opacity: 1}}>
                <h2>Accessibility</h2>
                <hr></hr>
                <p>
                Hotel employees from the adjacent Paramount Hotel complained about the attraction of people to the kiosk near their lobby. Vendors complained about people blocking customers from viewing their offerings. LinkNYC kiosks should consider expanding sidewalk rules for their sites, in conversation with vendors, building on their existing DOT standards.
                </p>
            </div>
            <div className="storytelling__text" style={{ top: `350vh` }}>
                <h2>Language</h2>
                <hr></hr>
                <p>
                There were conversations happening in eight languages around this kiosk. As a public service, LinkNYC should strengthen its multi-lingual services by providing advertisements, privacy agreements, and other services in a variety of languages, similarly to the way most other NYC agencies do. </p>
            </div>
            <div className="storytelling__text" style={{ top: `450vh` }}>
                <h2>Vendors</h2>
                <hr></hr>
                <p>
                Every vendor had a strong opinion about the LinkNYC kiosks. In my observations, the kiosks seemed to actually be a significant boon to their businesses, with vendors using the structures to keep their phones charged, to prop up their signage, and, in one extraordinary case, to complete a caricature over FaceTime of a client’s brother in Mexico. Engagement with vendors can invigorate entrepreneurial energy and create stronger relationships on the street.  
                </p>
            </div>
            <div className="storytelling__text" style={{ top: `550vh` }}>
                <h2>Transit Oriented</h2>
                <hr></hr>
                <p>
                Many people used this site, more than any other that I visited, in part due to its location as both an entertainment and commuting hub. The ability to access these public WiFi services in relation to transit could be greatly strengthened. Future LinkNYC kiosks should be sited close to transit hubs, similarly to how the City sites bike parking racks in proximity to bike lanes. </p>
            </div>
            <div className="storytelling__end" style={{ top: `650vh` }}>
                <h2><a className="ending__links" href="https://greenwood-walkthrough.vercel.app/">Greenwood</a></h2>
                <h2><a className="ending__links"  href="https://lawrence-walkthrough.vercel.app/">Lawrence</a></h2>
                <h2><a className="ending__links"  href="https://harlem-walkthrough.vercel.app/">Harlem</a></h2>
            </div>
        </Scroll>
    </>

}